import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PinIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path
      d="M10.6666 6.00001V2.66668h.6667c.3666 0 .6666-.3.6666-.66667s-.3-.66667-.6666-.66667H4.66659c-.36667 0-.66667.3-.66667.66667s.3.66667.66667.66667h.66666v3.33333c0 1.10667-.89333 2-2 2v1.33333h3.98V14l.66667.6667L8.64659 14V9.33334h4.02001V8.00001c-1.1067 0-2-.89333-2-2Z"
      clipRule="evenodd"
    />
  </Icon>
);

export default memo(PinIcon);
